module.exports = __webpack_public_path__ + "static/download.56c76da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/icon/download.jpg
// module id = 163
// module chunks = 166730631587841 202407051893895